import * as api from "./instantAuditsAdminApi";

function removeDeleted(input) {
  if(Array.isArray(input)){
    return input.filter(item => !item.deleted).map(item => removeDeleted(item))
  } else if(typeof input === 'object'){
    const keys = Object.keys(input)
    let processed = {}
    for(let key of keys ) {
      processed = {...processed, [key]: removeDeleted(input[key])}
    }
    return processed
  } else { /* non objects/arrays can't contain deleted */
    return input
  }
}

export function updateInstantAuditRateLimits(model) {

  const promises = (model.configs || [])
    .filter(x => (!x.isNew || !x.deleted)) // remove new ones that are also deleted
    .map(({rateLimits, hostnameRateLimits, hostname, ...rest}) => {
      return {
        rateLimits: rateLimits && rateLimits.filter(x => !x.deleted).map(x => ({
          ...x,
          limits: x.limits && x.limits.filter(x => !x.deleted)
        })),
        hostnameRateLimits: hostnameRateLimits && hostnameRateLimits.filter(x => !x.deleted).map(x => ({
          ...x,
          limits: x.limits && x.limits.filter(x => !x.deleted)
        })),
        hostname: hostname || null,
        ...rest
      }
    })
    .map( config => {
      if (config.isNew) {
        return api.generateConfig(config)
      } else {
        return api.updateRateLimits(config)
      }
    })
  return Promise.all(promises)
}